import type { SchedulingResource } from '../../lib/api.js';

export function detailLabel(resource: SchedulingResource) {
  const count = resource.serviceIds.length;
  const services = count === 0 ? 'Nenhum serviço' : count === 1 ? '1 serviço' : `${count} serviços`;
  if (resource.kind === 'PROFESSIONAL') return services;
  const capacity = resource.capacity > 1 ? `${resource.capacity} ao mesmo tempo` : '1 por vez';
  return `${capacity} · ${services.toLowerCase()}`;
}
/// Onde as duas espécies aparecem juntas, como no bloqueio, a linha diz qual é qual.
export function resourceKindLabel(resource: SchedulingResource) {
  const kind = resource.kind === 'PROFESSIONAL' ? 'Profissional' : 'Sala';
  return `${kind} · ${detailLabel(resource).toLowerCase()}`;
}
